<template>
    <v-text-field
        class="body-2"
        :name="metadata.name"
        :value="value"
        :aria-label="formattedAriaLabel(
            metadata[`description${this.upperLocale}`],
            required
        )"
        :label="formattedLabel(
            metadata[`description${this.upperLocale}`],
            required
        )"
        :outlined="outlined"
        :append-icon="appendIcon"
        :color="$vuetify.theme.primary"
        :background-color="$vuetify.theme.primary"
        :placeholder="placeholder"
        autocomplete="off"
        :close-on-content-click="false"
        :rules="[
            !required || requiredField(),
            v => !v || getFormRule('futureDate', 'base.errors.travelDateFuture')(v),
            v => !v || getFormRule('validateDateIsInRange', 'base.errors.travelInvalidDateRange')(v, this.maxSelectableDate, this.minSelectableDate)
        ]"
        :data-meta-id="metadata.id"
        v-facade="$t('base.dateMask')"
        :id="metadata.name"
        @input="emitValue"
    />
</template>

<script>
import { inputHelpers } from '@/mixins/inputHelpers';
import { find } from 'lodash';
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';
import { ServiceSettings } from '@/enums';
import { timezoneUtc, FormatTimezone } from '@/mixins/timezones-utc/timezone-utc';

export default {
    name: 'travel-departure-date',
    mixins: [formRules, timezoneUtc, inputHelpers],
    props: {
        metadata: { type: Object, required: true },
        outlined: { type: Boolean, required: false, default: true },
        required: { type: Boolean, required: false, default: false },
        value: { type: String, required: false, default: '' },
        withIcon: { type: Boolean, required: false, default: false },
        placeholder: { type: String, required: false, default: '' },
    },
    computed: {
        ...mapGetters({
            locale: 'locale',
            upperLocale: 'upperLocale',
            currentEstSettings: 'services/getCurrentEstSettings',
        }),

        appendIcon() {
            return this.withIcon ? 'far fa-calendar-alt' : '';
        },
        maxDaysAhead() {
            let days = find(this.currentEstSettings, ['setting', ServiceSettings.TRAVEL_MAX_DAYS_AHEAD]);
            return days.value;
        },
        minSelectableDate() {
            return this.getCurrentDateString();
        },
        maxSelectableDate() {
            const date = this.createDateTimeAsUTC().plus({ day: this.maxDaysAhead ? this.maxDaysAhead : 365 });
            return this.formatDateTimeToString(date, FormatTimezone.ONLY_DATE);
        },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value);
        },
    },
};
</script>
